import { cn } from '@/frontend/lib/utils'

import type { FieldLayoutProps } from './form-layout-context'

/**
 * Tabular layout: Control → Error only.
 * No label or description is rendered. Intended for table-style forms where
 * column headers replace per-field labels.
 *
 * The error slot always reserves space (min-h) so that all cells in a row
 * stay the same height regardless of whether they have an error or not.
 */
export function TabularLayout({ control, error, className }: FieldLayoutProps) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1', className)}>
      {control}
      {error && <div className="font-medium text-destructive-fg">{error}</div>}
    </div>
  )
}
